export default {
    "statusBar": {
        "fullscreenTitleEnter": "Fullscreen",
        "fullscreenTitleExit": "Exit fullscreen",
        "networkActivity": "Network activity"
    }
};
